import { render } from "./ShareDialog.vue?vue&type=template&id=1d904c87&scoped=true"
import script from "./ShareDialog.vue?vue&type=script&lang=js"
export * from "./ShareDialog.vue?vue&type=script&lang=js"

import "./ShareDialog.vue?vue&type=style&index=0&id=1d904c87&scoped=true&lang=css"
import "./ShareDialog.vue?vue&type=style&index=1&id=1d904c87&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d904c87"]])

export default __exports__